import { render } from "./PercentNetRevenueValue.vue?vue&type=template&id=c6370636&scoped=true"
import script from "./PercentNetRevenueValue.vue?vue&type=script&lang=js"
export * from "./PercentNetRevenueValue.vue?vue&type=script&lang=js"

import "./PercentNetRevenueValue.vue?vue&type=style&index=0&id=c6370636&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6370636"]])

export default __exports__